module.exports = __webpack_public_path__ + "static/media/Show Password.b2768a3d.svg";